<template>
  <div class="px-4">
    <slot name="logo" />
  </div>
</template>
